import * as React from 'react';
import {
    Box,
    Container,
    Grid,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    Typography
} from '@mui/material'
import { useState } from 'react'
import { BiCog } from "react-icons/bi";

import { TitleText } from '../../../../common/styles/styled-components/StyledTypography'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import ProvisioningCard from './components/DomainConfigCard'
import { tenantProvisioningCardData } from './utils'
import CustomizedDialogs from './components/LegacyConfiguration';
import { BiRename } from "react-icons/bi";
import CloseIcon from '@mui/icons-material/Close';
import { SemiAutomatedProvisioning } from './components/SemiAutomatedProvisioningView';
import { AutomatedProvisioning } from './components/AutomatedProvisioningView';
import Button from '../../../../common/components/button/Button';
import { serviceSliceState } from '../../../../store/slice/serviceSlice';
import { useSelector } from 'react-redux';
import ConfirmationModal from '../../../../common/components/custom/modal/modal';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { customerProvisioningStatusesGet } from '../../../../api/orders/ordersAPI';
import { gettingCompanyId } from '../../../../helpers/HelperFunctions';
import { useEffect } from 'react';

function ManualConfigPopup(props) {

    const handleClose = () => {
        props.setOpen(false);
    };

    const redirectDoc = () => {
        window.open(process.env.REACT_APP_PROVISIONINGS_URL, '_blank');
        handleClose();
    };

    return (
        <React.Fragment>

            <Dialog
                onClose={handleClose}
                open={props.open}
                sx={{ maxWidth: '320px', margin: 'auto' }}
            >
                <DialogTitle sx={{ m: 0, p: 2 }}>
                    <IconButton aria-label="close" sx={{ boxShadow: 2, borderRadius: 2 }} >
                        <BiRename />
                    </IconButton>
                </DialogTitle>

                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>

                <DialogContent sx={{ p: 2 }}>
                    <Typography sx={{ fontWeight: 'bold' }}>Fully Manual Configuration</Typography>
                    <Typography
                        sx={(theme) => ({
                            color: theme.palette.grey[500],
                        })}
                    >For user who wants to perform every steps manually inside the Microsoft 365 Admin Portal</Typography>
                </DialogContent>
                <Box sx={{ p: 2 }}>
                    <Button variant='contained'
                        text="Open Documentation"

                        onClick={redirectDoc}
                        // onClick={handleClose} 
                        sx={{ width: '100%' }}
                    />
                </Box>
            </Dialog >
        </React.Fragment>
    );
}

export default function TenantProvisioning(props) {
    const [openLegacyConfForm, setOpenLegacyConfForm] = useState(false);
    const [openManualPro, setOpenManualPro] = useState(false);
    const [openSemiAutoPro, setOpenSemiAutoPro] = useState(false);
    const [openAutoPro, setOpenAutoPro] = useState(false);
    const serviceState = useSelector(serviceSliceState);
    const [otherTenantConfirmation, setOtherTenantConfirmation] = useState(false);
    const [provisioningStatus, setProvisioningStatus] = useState([]);
    const [newCustomer, setNewCustomer] = useState(false);


    const openProvisioningForm = (buttonAction) => {
        if (buttonAction === 'MP') {
            setOpenManualPro(true);
        } else if (buttonAction === 'AP') {
            props.onAdministrate(true);
            props.setIsProvisioningStarting(true);
        } else if (buttonAction === 'SAP') {
            setOpenSemiAutoPro(true);
        }
    }

    const getProvisioningStatus = async () => {
        const companyId = gettingCompanyId([])
        const response = await customerProvisioningStatusesGet(
            { companyId },
            companyId
        )
        if (response?.data.length == 0) {
            setNewCustomer(true);
        } else { setProvisioningStatus(response?.data); setNewCustomer(false); }
    }

    useEffect(() => {
        getProvisioningStatus();
    }, []);

    return (
        <Container maxWidth="xl">
            <div>
                <Box>
                    <div style={{ textAlign: 'left' }}>
                        <IconButton onClick={() => props.showTenantConfig(false)}>
                            <KeyboardBackspaceIcon sx={{ height: '20px', width: '20px' }} />
                            <span style={{ margin: '5px', fontSize: '14px' }}>Go Back</span>
                        </IconButton>
                    </div>

                    <Box display='flex' justifyContent='space-between'>
                        <Box>
                            <TitleText sx={{ fontSize: '24px', textAlign: 'left' }}>Tenant Provisioning</TitleText>
                            <TitleText sx={{ fontWeight: '400' }}>Choose your preferred setup method below</TitleText>
                        </Box>
                        <Box mr={4}>
                            <Button
                                variant="outlined"
                                text="Teams Configuration"
                                startIcon={<BiCog />}
                                sx={{ color: '#464343', border: '1px solid gray' }}
                                onClick={() => props.onAdministrate(true)}
                            />
                        </Box>
                    </Box>

                </Box>
                <Grid style={{ padding: '10px 0' }} container xs={12} sm={12} spacing={3}>
                    {tenantProvisioningCardData.map((cardData, index) => (
                        <Grid item xs={4} key={index}>
                            <ProvisioningCard
                                cardData={cardData}
                                openProvisioningForm={openProvisioningForm}
                                serviceState={serviceState}
                                viewProvisioningStatus={() => setOpenAutoPro(true)}
                                statusData={provisioningStatus.filter((st => st.type == index))}
                                newCustomer={newCustomer}
                            />
                        </Grid>
                    ))}
                </Grid>

                <CustomizedDialogs open={openLegacyConfForm} setOpen={setOpenLegacyConfForm} />
                <ManualConfigPopup open={openManualPro} setOpen={setOpenManualPro} />

                <SemiAutomatedProvisioning
                    open={openSemiAutoPro}
                    setOpen={setOpenSemiAutoPro}
                    getProvisioningStatus={getProvisioningStatus}
                    goToServiceFunction={props?.goToServiceFunction}
                    data={provisioningStatus.filter((st => st.type == 1))}

                />

                <AutomatedProvisioning
                    open={openAutoPro}
                    setOpen={setOpenAutoPro}
                    openLegacyConfForm={() => {
                        setOpenAutoPro(false);
                        setOtherTenantConfirmation(true)
                    }}
                    data={provisioningStatus.filter((st => st.type == 0))}

                />

                <ConfirmationModal
                    title={'Confirmation'}
                    content="Warning: This will re-provision your existing tenant setup and eliminate the old setup. Would you like to proceed?"
                    isOpen={otherTenantConfirmation}
                    infoIcon={<WarningAmberIcon sx={{ fontSize: '60px', color: 'rgb(249 207 4)' }} />}
                    handleConfirm={() => {
                        setOtherTenantConfirmation(false);
                        props.setIsNewTenantPro(true);
                        props.onAdministrate(true);
                    }}
                    handleClose={() => {
                        setOtherTenantConfirmation(false)
                        setOpenAutoPro(true);
                    }}
                />
            </div>
        </Container>
    )
}
